<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <terminalCompanypriceAction v-if="showStatus" ref="terminalCompanypriceAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></terminalCompanypriceAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <el-form @submit.native.prevent label-width="100px" :inline="true" size="mini" ref="SEARCH" :model="getRequestData" class="demo-form-inline" :inline-message="false" :show-message="false">
                    <el-form-item label="开始日期" prop="start">
                        <label slot="label" :style="$common.labelStyle('开始日期')" v-html="$common.htmlLabel('开始日期')"></label>
                        <el-date-picker @clear="timeClear('start')" class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="end">
                        <label slot="label" :style="$common.labelStyle('结束日期')" v-html="$common.htmlLabel('结束日期')"></label>
                        <el-date-picker @clear="timeClear('end')" class="form_codition" @change="changeTime" size="mini" v-model="getRequestData.end" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="终端公司" prop="tcmId">
                        <label slot="label" :style="$common.labelStyle('终端公司')" v-html="$common.htmlLabel('终端公司')"></label>
                        <el-input @clear="initParamValue('tcmName,tcmId')" clearable v-model="getRequestData.tcmName" @keyup.enter.native="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId')">
                            <el-button @click="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId')" slot="append" icon="el-icon-search">
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="医院" prop="hospitalId">
                        <label slot="label" :style="$common.labelStyle('医院')" v-html="$common.htmlLabel('医院')"></label>
                        <el-input @clear="initParamValue('hospitalName,hospitalId')" clearable v-model="getRequestData.hospitalName"
                                  @keyup.enter.native="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId')">
                            <el-button @click="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId')" slot="append" icon="el-icon-search">
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="bgmName">
                        <label slot="label" :style="$common.labelStyle('商品名称')" v-html="$common.htmlLabel('商品名称')"></label>
                        <el-input @clear="initParamValue('bgmName,bgmId')" clearable v-model="getRequestData.bgmName" @keyup.enter.native="openSearch(853533363572736, 0, 'bgmName', 'bgmName,bgmId')">
                            <el-button @click="openSearch(853533363572736, 0, 'bgmName', 'bgmName,bgmId')" slot="append" icon="el-icon-search">
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table @selection-change="handleSelectionChange" size="mini" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgmCode" label="商品编码"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgmName" label="商品名称"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="spec" label="规格"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="manufacturer" label="生产厂家"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="psprice" label="价格"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="bgiBrand" label="品牌"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="hospitalName" label="医院"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="tcmName" label="终端公司"></el-table-column>
                <el-table-column align="center" show-overflow-tooltip min-width="120" prop="placeorigin" label="产地"></el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <el-dialog title="导入" v-if="importShow" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload v-if="importShow" :parentSearchData="importObj" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import terminalCompanypriceAction from '@/components/terminalCompanypriceAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        terminalCompanypriceAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                hospitalId: "",
                hospitalName: "",
                tcmId: "",
                tcmName: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},

            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //--------------
            importShow: false,
            importType: "",
            url: "",
            importObj: {
                coId: "",
                stId: "",
            },

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 触发组件的提交
        fileSuccess(val) {
            this.getDataList()
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/terminalCompanyPrice/downloadTemplate`
        },
        importDetails() {
            this.importType = 'terminalCompanyPriceimport'
            this.url = 'terminalCompanyPrice/import'
            this.importShow = true
        },
        timeClear(val) {
            if (this.getRequestData[val] == null) {
                this.getRequestData[val] = "";
            }
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        getPageInfo() {
            var obj = {}
            obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList();
            this.getDataList();
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 1:
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: "请勾选一条数据操作",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.multipleSelection[0]
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.id,
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.importDetails();
                    break;
                case 4:
                    this.exportTemplate();
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.terminalCompanyPricequery(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                return
            } else if (this.multipleSelection.length <= 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.terminalCompanyPricedelete({ ids: this.multipleSelection.map(item => item.id) });
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>